import tag from '@js/store/modules/tag';

export default {
    created() {
        if (!this.$store.hasModule('tag')) {
            this.$store.registerModule('tag', tag);
        }
    },
};
